import { Link as CoreLink } from '@reach/router';

export default CoreLink;
